// Contrat proposé par le lot L0-D pour les préférences personnelles (H9-01, H9-02, R17), aligné
// sur la table identite.preference de la migration 0004. La route n'existe pas encore dans
// l'API du lot L0-A : GET /preferences et PUT /preferences, portée du compte (toutes
// collectivités, tous appareils). L'interface l'utilise dès qu'elle répond.
import { z } from 'zod';

export const THEMES = ['jour', 'nuit', 'systeme'] as const;
export const DENSITES = ['confortable', 'compacte'] as const;
export const TAILLES_POLICE = ['normale', 'grande'] as const;

/** Disposition d'un tableau de bord : ordre des tuiles et tuiles masquées. */
export const schemaDisposition = z.object({
  ordre: z.array(z.string().max(64)).max(100),
  masquees: z.array(z.string().max(64)).max(100),
});
export type Disposition = z.infer<typeof schemaDisposition>;

export const schemaPreferences = z.object({
  theme: z.enum(THEMES),
  densite: z.enum(DENSITES),
  taille_police: z.enum(TAILLES_POLICE),
  /** Clé : identifiant du tableau de bord (par exemple « maire », « secretaire_general »). */
  dispositions: z.record(z.string().max(64), schemaDisposition),
  filtres_favoris: z.record(z.string().max(64), z.record(z.string().max(64), z.string().max(200))),
});
export type Preferences = z.infer<typeof schemaPreferences>;

/** Écriture partielle : seules les clés fournies sont remplacées. */
export const schemaEcriturePreferences = schemaPreferences.partial();

export const PREFERENCES_PAR_DEFAUT: Preferences = {
  theme: 'systeme',
  densite: 'confortable',
  taille_police: 'normale',
  dispositions: {},
  filtres_favoris: {},
};
